import '../App.css';
import { Button, Navbar, Nav } from 'react-bootstrap';
import 'sf-font';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram, faDiscord } from '@fortawesome/free-brands-svg-icons';
import React, { Component } from 'react';

class App extends Component {
 
  
  render() {
   
    const currentYear = new Date().getFullYear();

return (

  <header className="App-header">
    <div className='container' style={{ background: "#000000" }}>
      
     
    <div className="nftminter" style={{ border: "0", borderRadius: "5px", background: "transparent", marginTop: "10px", marginBottom: "10px", }}>
             
             <Navbar collapseOnSelect expand="md"  variant="dark" style={{ color: 'transparent', background: "transparent", marginRight: "3px",marginLeft: "3px", border: "0", }}>
             
             
             <div className="social-icons">
             <a href="https://twitter.com/JustPoly">
   <FontAwesomeIcon icon={faTwitter} type= "button"size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faTelegram} size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faDiscord} size="lg" className="social-icon" />
   </a>
   
   <style>
     {`
       .social-icons {
         display: flex;
         justify-content: center;
       
         color: #ccc;
         margin-right: auto;
       }

       .social-icon {
         margin-right: 10px;
         margin-left: 10px;
       }

       a {
         color: #ccc;
       }
       a:hover {
         color:#aaa;
        
       }


       @media (max-width: 768px) {
         .social-icons {
           display: flex;
           justify-content: left;
          
           color: #ccc;
           
        
         }
       }
     `}
   </style>
 </div>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{color:"transparent", background: "transparent", marginTop: "auto", border: "0", }}/>
       
        <Navbar.Collapse id="responsive-navbar-nav"  style={{textAlign: "left", background: "transparent", marginTop: "auto", border: "0", }}>
        
         <Nav className="mr-auto ml-auto ml-lg-0" >
         <Button variant="default" href="/" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>HOME</Button>
         <Button variant="default" href="/about" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>ABOUT</Button>
         <Button variant="default" href="/tokenInfo" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >TOKEN INFO</Button>
         <Button variant="default" href="/roadmap" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >ROADMAP</Button>
         <Button variant="default" href="" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >STAKED</Button>    
       </Nav></Navbar.Collapse></Navbar></div>

         


 
<div className='nftminter' style={{ background: "transparent", marginTop: "auto", border: "0", }}>
               
<label id='text' style={{ textAlign: "left", color: "#ccc",marginTop: "auto", fontWeight: "bold", fontSize: "15px" }}>
              
            
                       
<p>1 - Initial Stage Preparation and Launch : </p>
<ul>
<li>Forming the core project team and conducting in-depth research on community needs.</li>
<li>Designing and building the Just Poly platform.</li>
<li>Launching the official website and social media channels for community interaction.</li>
</ul>

<p>2 - Introduction of Just Poly Genesis NFTs : </p>
<ul>
<li>Issuing and launching Just Poly Genesis NFTs to provide community members with exclusive access.</li>
<li>Organizing a launch event for Just Poly Genesis NFTs to generate interest and engage community members.</li>
</ul>

<p>3 - Community Building : </p>
<ul>
<li>Hosting competitions and creative challenges to encourage community member participation.</li>
<li>Building an online community forum for collaboration and discussion.</li>
<li>Conducting webinars and workshops to facilitate knowledge and skill exchange among community members.</li>
</ul>
    

<p>4 - Development of the Just Poly Ecosystem : </p>
<ul>
<li>Establishing strategic partnerships with other projects on the Polygon network to expand the Just Poly ecosystem.</li>
<li>Introducing new features and functionalities to the Just Poly platform based on community feedback.</li>
<li>Enhancing the user experience through platform optimization and integration of the latest technologies.</li>
</ul>   

<p>5 - Community Rewards and Benefits Development :</p>
<ul>
<li>Creating incentive programs for active and contributing community members.</li>
<li>Introducing staking or yield farming with JP tokens as a form of appreciation to community members.</li>
<li>Launching an ambassador program to broaden the reach of Just Poly to more potential users.</li>
</ul>

<p>6 - Growth and Expansion :</p>
<ul>
<li>Implementing extensive marketing strategies to increase awareness and adoption of Just Poly.</li>
<li>Establishing partnerships with leading crypto exchange platforms to expand the availability of JP tokens.</li>
<li>Exploring expansion opportunities into other blockchain networks to broaden the reach of Just Poly.
</li></ul>

      <style>
        {`
      

       c {
           max-width: 800px;
            margin: 10px;
          }

        h1, h2, p, li {
          text-align: left;
          margin: 10px;
        
          max-width: auto;
          font-weight:bold;
          color:#ccc;
        }
        h2 {
         
          margin-top: 10px;
        
        }
        ul {
          padding-left: 20px;
          margin: auto;
          
          
        }

        @media (max-width: 768px) {
          c {
            font-size: 12px;
            margin: auto;
            text-align: left;
            
          }
        }
      `}</style>
                  </label>
              </div>

              
        




      
      <div className='footer' style={{ background: "transparent", border: "0" }}>
        <div className='col'>
         
          <b>&copy; {currentYear} JUST POLY DAPP</b>
          <style>{`
  
        b {
          text-align: center;
          font-size: 14px;
          font-weight: arial;
        }

      
      `}</style>
        </div>
      </div>
    </div>
  </header>
);
}
}

export default App;